<!-- 步骤进度条组件 -->
<template>
  <div class="step-progress-container">
    <div class="step-progress-wrapper">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item-wrapper"
      >
        <!-- 步骤项 -->
        <div
          class="step-item"
          :class="{
            'is-active': index === currentStep,
            'is-completed': index < currentStep,
            'is-clickable': clickable
          }"
          @click="handleStepClick(index)"
        >
          <div class="step-content">
            <span class="step-text">{{ step.label }}</span>
          </div>
        </div>

        <!-- 箭头连接（最后一个不显示） -->
        <div
          v-if="index < steps.length - 1"
          class="step-arrow"
          :class="{
            'is-active': index < currentStep
          }"
        >
          <img
            class="step-arrow-img"
            src="@/assets/img/step-arrow.png"
            alt="arrow"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 步骤进度条组件
 * 功能说明：显示步骤流程，支持点击跳转
 *
 * @props {Number} currentStep - 当前步骤索引（从0开始）
 * @props {Boolean} clickable - 是否可点击跳转，默认true
 * @props {Array} steps - 步骤配置数组，格式：[{label: '步骤名称', route: '/path'}]
 */
export default {
  name: 'StepProgress',
  props: {
    // 当前步骤索引（从0开始）
    currentStep: {
      type: Number,
      default: 0
    },
    // 是否可点击跳转
    clickable: {
      type: Boolean,
      default: true
    },
    // 步骤配置
    steps: {
      type: Array,
      default: () => [
        { label: '选取论文', route: '/steps/paperList' },
        { label: '邮件模板', route: '/steps/emailTemplate' },
        { label: '遴选学者', route: '/steps/selectScholars' },
        { label: '查看学者', route: '/steps/viewScholars' },
        { label: '推送测试', route: '/steps/pushTest' },
        { label: '正式推送', route: '/steps/officialPush' }
      ]
    }
  },
  methods: {
    /**
     * 处理步骤点击
     */
    handleStepClick(index) {
      if (!this.clickable) return

      const step = this.steps[index]
      if (!step || !step.route) {
        // 触发事件，让父组件处理
        this.$emit('step-click', index, step)
        return
      }

      // 获取当前路由的 taskId 参数
      const taskId = this.$route.query.taskId

      // 构建跳转路由，如果有 taskId 则拼接到路由后面
      let targetRoute = step.route
      if (taskId) {
        const separator = targetRoute.includes('?') ? '&' : '?'
        targetRoute = `${targetRoute}${separator}taskId=${taskId}`
      }
      let query = { ...this.$route.query }
      if (query && query.viewType) {
        delete query.viewType
      }
      this.$router.push({
        path: targetRoute,
        query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.step-progress-container {
  width: 100%;

  .step-progress-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
  }

  .step-item-wrapper {
    display: flex;
    align-items: center;

    .step-item {
      width: 120px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #4054af;
      border-radius: 4px;
      background: #fff;
      color: #4054af;
      font-size: 14px;
      font-weight: 600;
      transition: all 0.3s ease;
      position: relative;
      box-sizing: border-box;

      .step-content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .step-text {
          white-space: nowrap;
        }
      }

      &.is-active {
        background: #4054af;
        border-color: #4054af;
        color: #fff;
        font-weight: 600;
        box-shadow: 0 2px 8px #9aacfa;
      }

      // 可点击样式
      &.is-clickable {
        cursor: pointer;

        &:hover:not(.is-active) {
          background: #9aacfa40;
          border-color: #4054af;
          transform: translateY(-2px);
          box-shadow: 0 2px 8px #9aacfa;
        }
      }
    }

    .step-arrow {
      margin: 0 16px;
      color: #dcdfe6;
      font-size: 20px;
      transition: color 0.3s ease;

      &.is-active {
        color: #4054af;
      }
      .step-arrow-img {
        width: 28px;
      }
    }
  }

  // 响应式：页面宽度小于1400px时缩小0.2倍
  @media screen and (max-width: 1400px) {
    transform: scale(0.8);
    transform-origin: center center;
  }
}
</style>
